import { ApiCore } from "@/services/api/utils/core.js";
import { apiProvider } from "@/services/api/utils/provider.js";
import axios from "axios";
import { handleResponse, handleError } from "@/services/api/utils/response.js";

const url = "v1/package";

const api = new ApiCore({
	index: true,
	create: true,
	url: url,
});

api.getAllPackages = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`, { params })
		.then(handleResponse)
		.catch(handleError);
};

api.getPackageDetails = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${id}`)
		.then(handleResponse)
		.catch(handleError);
};

api.updatePackage = (id, payload, options) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${id}/data-elements`, payload, options)
		.then(handleResponse)
		.catch(handleError);
};

api.addRemoveDataElements = (eclipId, payload) => {
	return axios
		.post(
			`${apiProvider.BASE_URL}/${url}/${eclipId}/data-elements`,
			payload
		)
		.then(handleResponse)
		.catch(handleError);
};

api.listDataElements = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/data-elements`, { params })
		.then(handleResponse)
		.catch(handleError);
};

api.activityLog = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${id}/activity-log`)
		.then(handleResponse)
		.catch(handleError);
};

api.createActivityLog = (id, payload, options) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${id}/activity-log`, payload, options)
		.then(handleResponse)
		.catch(handleError);
}

api.pinPackage = (action, payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/pin-to-top/${action}`, payload)
		.then(handleResponse)
		.catch(handleError);
};

api.getFilterOptions = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/filters`, { params })
		.then(handleResponse)
		.catch(handleError);
};

api.setRefNumber = (id, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${id}/reference-number`, payload)
		.then(handleResponse)
		.catch(handleError);
};

api.getPackageComment = (packageCommentsId) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/node/PACKAGE/${packageCommentsId}`)
		.then(handleResponse)
		.catch(handleError);
};

api.updatePackageComment = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/node`, payload)
		.then(handleResponse)
		.catch(handleError);
};

api.getParticipants = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/participants`, { params })
		.then(handleResponse)
		.catch(handleError);
};

api.importMessageData = (eclipId, messageStoreId, payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${eclipId}/data-element-import/${messageStoreId}`, payload)
		.then(handleResponse)
		.catch(handleError);
};

api.sendPackage = (id) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${id}/send`)
		.then(handleResponse)
		.catch(handleError);
};

api.getReceivedPackages = (dataElementId, params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/received/${dataElementId}`,{params})
		.then(handleResponse)
		.catch(handleError);
};

api.getReceivedMessages = (dataElementId, options) => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/data-element/${dataElementId}/received-messages`, options)
		.then(handleResponse)
		.catch(handleError);
}

api.clearImportData = (eclipId, dataElementId, parentNodeType, parentNodeId) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/${eclipId}/imported/${dataElementId}/${parentNodeType}/${parentNodeId}`)
		.then(handleResponse)
		.catch(handleError);
}

api.updateIsNew = (eclipId, dataElementId, payload) =>{
	return axios
	.post(`${apiProvider.BASE_URL}/${url}/${eclipId}/${dataElementId}/updateIsNew`,payload)
	.then(handleResponse)
	.catch(handleError);
}

api.getPackageDEPayload = (eclipId, dataElementId, params) =>{
	return axios
	.get(`${apiProvider.BASE_URL}/${url}/${eclipId}/${dataElementId}`,{params})
	.then(handleResponse)
	.catch(handleError);
}


export default api;
